const STORES = {
  'prostores': [
    {
      'name': 'Spotify',
      'dsp': 746109
    },
    {
      'name': 'Apple Music',
      'dsp': 1330598
    },
    {
      'name': 'Deezer',
      'dsp': 2100357
    },
    {
      'name': 'SoundCloud',
      'dsp': 35299696
    },
    {
      'name': 'Amazon',
      'dsp': 99268
    },
    {
      'name': 'Pandora',
      'dsp': 7851192
    },
    {
      'name': 'Boomplay',
      'dsp': 1514168496
    },
    {
      'name': 'iHeartRadio',
      'dsp': 3441649
    },
    {
      'name': 'Instagram / Facebook',
      'dsp': 1499657856
    },
    {
      'name': 'Facebook Fingerprinting',
      'dsp': 1415672002
    },
    {
      'name': 'LINE Music',
      'dsp': 1232212955
    },
    {
      'name': 'TIDAL',
      'dsp': 3440259
    },
    {
      'name': 'TikTok',
      'dsp': 1809226414
    },
    {
      'name': 'Resso',
      'dsp': 1963181516
    },
    {
      'name': 'YouTube Music',
      'dsp': 3405271817
    }
  ]
}

export default STORES



// WEBPACK FOOTER //
// ./src/data/distributionstores.js